scrollButton = {
    init() {
        const button = document.querySelector('.hero__container__scroll')

        button?.addEventListener('click', () => {
            document.getElementById('intro').scrollIntoView({ behavior: "smooth" })
        });
    }
}

export let scrollButton;